import { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { useSearchParams } from 'react-router-dom';

import usePostShopeeCallback from 'Domain/shopee/usePostShopeeCallback';

const ShopeeCallback = () => {
  const { mutate: onPostShopeeCallback } = usePostShopeeCallback();
  const [params] = useSearchParams();

  useEffect(() => {
    if (params) onPostShopeeCallback(params);
    // eslint-disable-next-line
  }, [params]);

  return <Box />;
};

export default ShopeeCallback;
